<template>
<main id="searchMain" v-bind:class="{ 'active' : searching || static, 'reset' : reset }">
    <section class="offer" v-if="searching || static">
        <div class="container-fluid">
            <div class="breadcrumb clearfix">
                <ul class="list-inline pull-left">

                    <!-- Title category -->
                    <li v-if="!canSearch && category" @click="changeSubCategory(null)"><h4>{{ subcategory ? category.name : 'Všetky druhy' }}<i class="fa fa-chevron-right"></i></h4></li>
                    <li v-if="!canSearch && category"><h3>{{ subcategory ? subcategory.name : category.name }}</h3></li>

                    <li v-if="canSearch || !category"><h4>Vyhľadávanie<i class="fa fa-chevron-right"></i></h4></li>
                    <li v-if="canSearch || !category">
                        <h3 v-if="!brand">{{ categorySearch ? categorySearch.name : 'Všetky kategórie' }} <i class="fa fa-chevron-right" v-if="brand && !canSearch"></i></h3>
                        <h4 v-if="brand">{{ categorySearch ? categorySearch.name : 'Značka' }} <i class="fa fa-chevron-right" v-if="brand && !canSearch"></i></h4>
                        </li>
                    <li v-if="(!category) && brand && !canSearch"><h3>{{ brand.name }}</h3></li>

                    <li v-if="category && Object.keys(category.getOpeningHours).length" v-bind:class="['status', (category.isOpened ? '' : 'closed')]"><h5>{{ category.isOpened ? 'Otvorené' : 'Zatvorené' }}</h5></li>
                    <li v-if="category && Object.keys(category.getOpeningHours).length" class="hours">
                        <div class="dropdown">
                            <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                Zobraziť otváracie hodiny
                                <i class="fa fa-angle-down"></i>
                            </button>
                            <ul class="dropdown-menu times-menu" aria-labelledby="dropdownMenu1">
                                <li v-for="(times, day) in category.getOpeningHours">
                                    <ul class="list-inline clearfix list-inline-inner times">
                                        <li>{{ day }} <span v-if="times[1]">- {{ times[1] }}</span> <span class="dott">:</span></li>
                                        <li>{{ times[0][0] }} - {{ times[0][1] }}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>

                <div class="pull-right">
                    <div class="loading" v-show="loading"><i class="updatingAnimation fa fa-refresh"></i> Vyhľadávam...</div>
                    <div v-show="!loading"></div>
                </div>
            </div>
            <div class="offer-content">
                <div class="row">
                    <div class="col-sm-3 col-left" v-if="!isFullLayout">
                        <ul class="list-group" v-if="category && !searching">
                            <li>
                                <h4>Podkategória</h4>
                            </li>
                            <li v-bind:class="[(subcategory && subcategory.id == item.id) ? 'active' : '']" v-for="item in category.subs">
                                <a @click="changeSubCategory(item)">{{ item.name }} <span class="label-in pull-right"><p>{{ productsInSubCategory(item) }}</p></span></a>
                            </li>
                        </ul>
                        <price-table :prices="prices" :products="productsByCategory" :category="category"></price-table>

                        <variants-list v-for="(variant, key) in availableVariants" :variants="variants" :default="variants[key]" :variantid="key" :key="key" :products="productsByPrice" :variant="variant"></variants-list>
                    </div>

                    <div v-bind:class="['col-sm-'+( !isFullLayout ? 9 : 12 ), 'col-right']">
                        <div class="row">

                            <div class="col-lg-12 content-text" v-if="!canSearch && category && (category.image || category.content)">
                                <img v-if="category.image" v-bind:src="category.image" class="header-image">

                                <div v-if="category.content">
                                    <div class="text-limit" v-bind:class="{ full : show_content}">
                                        <div v-html="category.content"></div>
                                    </div>
                                    <button class="btn blue-btn add-btn read-more" @click="show_content = true" v-if="!show_content">Čítaj viac...</button>
                                </div>
                            </div>

                            <div class="col-lg-12 variant-items" v-if="variant && variant.in_category">
                                <div class="row" v-for="chunk in chunkVariantItems">
                                    <div class="col-md-2" @click="setVariant(variant.id, item.id)" :class="{ active : variant.id in variants && variants[variant.id] == item.id }" v-for="item in chunk">
                                        <div class="image">
                                            <img :src="item.image">
                                        </div>
                                        <a>{{ item.name }}</a>
                                    </div>
                                </div>
                            </div>


                            <div class="col-lg-12" v-if="productsLimited.length == 0 && !loading">
                                <div class="alert alert-warning" v-if="canSearch || !category">
                                    <strong>Informácia:</strong> Neboli nájdené žiadne produkty podľa vaších kritérii.
                                </div>
                                <div class="alert alert-warning" v-else>
                                    <strong>Informácia:</strong> V danej kategórii sa nenachádzaju žiadne produkty.
                                </div>
                            </div>

                            <!-- Filter -->
                            <div v-else class="col-lg-12 clearfix filter">
                                <ul class="list-inline clearfix">
                                    <li class="pull-left grid-box">
                                        <a v-bind:class="{ 'active' : layout.size == 'vertical' }" @click="changeLayout('vertical')"><i class="fa fa-th-large" aria-hidden="true"></i></a>
                                        <a v-bind:class="{ 'active' : layout.size == 'horizontal' }" @click="changeLayout('horizontal')"><i class="fa fa-bars" aria-hidden="true"></i></a>
                                    </li>
                                    <li class="pull-right">
                                        <div class="dropdown">
                                            <span class="sm-txt">Zoradiť podľa:</span>

                                            <button class="btn dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                                                <span v-if="!prices.orderBy">Všetky</span>
                                                <span v-if="prices.orderBy == 'asc'">Najlacnejšie</span>
                                                <span v-if="prices.orderBy == 'desc'">Najdrahšie</span>

                                                <i class="fa fa-angle-down"></i>
                                            </button>
                                            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                                                <li><a @click="prices.orderBy = null">Všetky</a></li>
                                                <li><a @click="prices.orderBy = 'asc'">Najlacnejšie</a></li>
                                                <li><a @click="prices.orderBy = 'desc'">Najdrahšie</a></li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!-- END Filter -->

                            <div id="productWrapper">
                                <!-- HORIZONTAL -->
                                <div class="items" v-if="layout.size == 'horizontal'">
                                    <div class="col-lg-12 list-item fadeIn animated" v-for="product in productsLimited" :key="product.id">
                                        <div class="row">
                                            <div v-bind:class="['col-sm-' + (categoryLayout == 'horizontal' ? 6 : 4), 'col-list-1']">
                                                <a v-bind:href="getProductAction(product)">
                                                    <img v-bind:src="getImagePath(product, categoryLayout)" alt="">
                                                    <div v-if="product.quantity <= 0" class="notenought">nie je skladom</div>
                                                </a>

                                                <div v-if="product.is_cold" class="cold_icon"></div>
                                                <div v-if="product.price_from && product.price_from > product.price" class="percentil">%</div>
                                            </div>
                                            <div v-bind:class="['col-sm-' + (categoryLayout == 'horizontal' ? 6 : 8), 'col-list-2']">
                                                <div class="product-list-info">
                                                    <h4><a v-bind:href="getProductAction(product)">{{ product.name }}</a></h4><span class="sm-txt">{{ product.variant }}</span>
                                                    <h4 class="price">{{ product.price }} €
                                                        <span class="sm-txt" v-if="product.price_from && product.price_from > product.price"><s>{{ product.price_from }}</s> €</span>
                                                    </h4>
                                                    <p>{{ product.description }}</p>
                                                    <div class="buttons">
                                                        <a v-bind:href="getProductAction(product)"><button class="btn blue-btn">Zobraziť produkt</button></a>
                                                        <button @click="addToBasket(product)" class="btn blue-btn">Pridať do košíka</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-lg-12 hr"><hr></div>
                                        </div>
                                    </div>
                                </div>
                                <!-- / HORIZONTAL -->

                                <!-- VERTICAL -->
                                <div class="items" v-if="layout.size == 'vertical'">
                                    <div class="col-lg-12">
                                        <div class="row" v-for="i in Math.ceil(productsLimited.length / 4)">
                                            <div class="col-xs-6 col-sm-3 col popular-product-item fadeIn animated" v-for="product in productsLimited.slice((i - 1) * 4, i * 4)" :key="product.id">
                                                <div class="some-div">
                                                    <a v-bind:href="getProductAction(product)" class="link-gallery">
                                                        <div class="blue-hov element1">
                                                            <span>Zobraziť produkt</span>
                                                            <button @click.prevent="addToBasket(product)" class="btn blue-btn">Pridať do košíka</button>
                                                        </div>
                                                        <img v-bind:src="getImagePath(product, 'vertical')" class="img-responsive img-gallery" alt="First image">

                                                        <button @click.prevent="addToBasket(product)" class="btn blue-btn btn-basket"><span class="fa fa-shopping-cart"></span></button>
                                                    </a>

                                                    <div v-if="product.is_cold" class="cold_icon"></div>
                                                    <div v-if="product.price_from && product.price_from > product.price" class="percentil">%</div>
                                                </div>
                                                <div class="product-info">
                                                    <h4 class="full"><a v-bind:href="getProductAction(product)">{{ limit(product.name, 40) }}</a></h4>
                                                    <h4 class="limited"><a v-bind:href="getProductAction(product)">{{ limit(product.name, 20) }}</a></h4>
                                                    <div class="quantity-status" :class="{ red : product.quantity <= 0, green : product.quantity > 0 }">{{ product.quantity <= 0 ? 'nie je skladom' : 'na sklade' }}</div>
                                                    <div>
                                                        <div class="pull-left">
                                                            <ul class="list-inline">
                                                                <li><span class="with">{{ product.price }} €</span></li>

                                                                <li v-if="product.price_from && product.price_from > product.price" class="without"><s>{{ product.price_from }}</s> €</li>
                                                            </ul>
                                                        </div>
                                                        <div class="pull-right">
                                                            <p>{{ product.variant }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- VERTICAL -->

                                <div class="col-md-12" v-if="layout.autolimit == false && productsSorted.length > maximumRows">
                                    <div class="text-center sendIt">
                                        <button class="btn blue-btn" @click="addMaximum(true)">Načítaj viac</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</main>
</template>

<script>
    import PriceTable from './PriceTable.vue';
    import VariantsList from './VariantsList.vue';

    export default {
        props : [
            'subcategoryid',
            'query',
            'requestquery',
            'static',
            'searchaction',
            'categoryaction',
            'search',
            'requesturl',
            'all'
        ],

        components : { PriceTable, VariantsList },

        data(){
            return {
                categories : window.Laravel.data.categories,
                category : window.Laravel.data.category,
                categorySearch : null,
                subcategory : null,
                brand : window.Laravel.data.brand,
                variant : window.Laravel.data.variant,
                variant_item : window.Laravel.data.variant_item,
                searching : false,
                reset : false,

                products : [],
                default_products : [],

                minimum_chars : 3,

                loading : false,
                show_content : false,

                //Previous url before searching
                previousurl : this.requesturl,

                //Layout for products
                layout : {
                    size : null,
                    autolimit : false,
                    maximum : {
                        vertical : 28,
                        horizontal : 6,
                    },
                    default_maximum : {},
                },

                //Prices filter
                prices : {
                    selected : null,
                    orderBy : null,
                },

                variants : {},
            };
        },

        created(){
            /*
             * Set products after app boot
             */
            this.setProducts();

            /*
             * Set subcategory by id
             */
            this.getSubcategory();

            /*
             * Set default layout products by category
             */
            this.setDefaultLayout();

            /*
             * Show if is static template
             */
            this.bootStaticTemplate();

            /*
             * Bind variants
             */
            this.bindVariantsByHashOrUrl();
        },

        watch: {
            query(value){
                this.updateResult(value);
            },
            searching(searching){
                this.$parent.searching = searching;

                var content = $('#app > main:not(#searchMain), .homepage > .bottom-nav > .background'),
                    footer = $('footer > section');

                //If is turned of searching, then show previous content
                if ( searching === false )
                {
                    content.show();

                    if ( ! footer.hasClass('hasSilver') )
                        footer.removeClass('silver');

                    this.reset = searching;
                }

                setTimeout(function(){
                    if ( searching === true ){
                        content.hide();

                        this.reset = searching;

                        footer.addClass('silver');
                    }
                }.bind(this), 170);
            },
            reset(value){
                this.$parent.reset = value;
            },
            loading(value){
                this.$parent.loading = value;
            },
        },

        computed: {
            chunkVariantItems(){
                return _.chunk(this.variant.items, 6);
            },
            productsByCategory(){
                //Filter by category
                return this.products.filter(function(item){
                    //check if froduct belongs to selected subcategory
                    if (
                        !(this.subcategory && !_.find(item.subcategories, { id : this.subcategory.id }))
                        || this.searching == true
                    )
                        return item;

                    return false;
                }.bind(this));
            },
            availableVariants(){
                var variants = {};

                this.productsByCategory.filter(product => {
                    if ( Object.keys(product.variants).length > 0 )
                    {
                        for ( var key in product.variants )
                        {
                            //Add all variants items into array
                            if ( !(key in variants) )
                                variants[key] = _.cloneDeep(product.variants[key]);
                            else {
                                for ( var k in product.variants[key].variants )
                                    variants[key].variants[k] = _.cloneDeep(product.variants[key].variants[k]);
                            }
                        }
                    }
                });

                return variants;
            },
            productsByPrice(){
                var items = this.productsByCategory;

                //Filter by price interval
                if ( this.prices.selected !== null )
                    items = this.filterByPrice(items, this.prices.selected);

                return items;
            },
            productsByVariants(){
                //Filter by category
                return this.productsByPrice.filter(function(product){
                    for ( var key in this.variants )
                    {
                        if ( this.variants[key] != null
                            && this.variants[key].length != 0
                            && key in this.availableVariants
                            && ! (
                                key in product.variants && product.variants[key].variants
                                && _.intersection(this.variants[key], Object.keys(product.variants[key].variants).map(item => {
                                    return parseInt(item);
                                })).length > 0
                            )
                        )
                            return false;
                    }

                    return true;
                }.bind(this));
            },
            productsSorted(){
                if ( this.prices.orderBy === null && this.searching === true )
                    return this.productsByVariants;

                return this.productsByVariants.sort(function(a, b){
                    if ( this.prices.orderBy === null )
                        return parseInt(b._order) - parseInt(a._order);

                    if ( this.prices.orderBy == 'asc' )
                        return parseInt(a.price) - parseInt(b.price);
                    else
                        return parseInt(b.price) - parseInt(a.price);
                }.bind(this));
            },
            productsLimited(){
                var products = this.productsSorted;

                return products.slice(0, this.maximumRows);
            },
            canSearch(){
                var can = this.query && this.query.length >= this.minimum_chars;

                //If is turned of searching, then display previous rows...
                if ( !can ){
                    this.resetSearching();
                }

                return can;
            },
            categoryLayout(){
                return this.category ? this.category.layout : 'vertical';
            },
            isFullLayout(){
                if ( ! this.category )
                    return false;

                if ( ! this.categorySearch && this.canSearch )
                    return false;

                if ( this.canSearch && this.category && this.categorySearch && this.category.slug != this.categorySearch.slug )
                    return true;

                return false;
            },
            maximumRows(){
                var limit;

                //Show number of rows from previous request
                if ( limit = this.getHashQuery('limit') )
                {
                    limit = parseInt(limit);

                    if ( limit > this.layout.maximum[this.layout.size] ){
                        return this.layout.maximum[this.layout.size] = limit;
                    }
                }

                return this.layout.maximum[this.layout.size];
            }
        },

        methods: {
            setVariant(variantid, id){
                this.$set(this.variants, variantid, id);

                this.setHashQuery(variantid, id);
            },
            /*
             * Set default variants by request
             */
            bindVariantsByHashOrUrl(){
                var param;

                if ( this.variant_item )
                    this.$set(this.variants, this.variant_item.variant_id, [parseInt(this.variant_item.id)])

                for ( var key in this.availableVariants )
                {
                    if ( (param = this.getHashQuery(key)) !== null ){
                        this.$set(this.variants, key, param.split(',').map(item => {
                            return parseInt(item);
                        }));
                    }
                }
            },
            getHashQuery(key, all){
                var hash = window.location.hash.substr(1),
                    params = hash.split('|').map(param => {
                        return param.split('=');
                    }).filter(param => {
                        if ( all && param[0] != key )
                            return true;
                        else if ( ! all && param[0] == key )
                            return true;
                    });

                if ( ! all )
                    return params.length > 0 ? params[0][1]||null : null;

                return params;
            },
            setHashQuery(key, value){
                var params = this.getHashQuery(key, true);

                params.push([key, value]);

                window.location.hash = params.map(param => {
                    if ( ! $.isArray(param) )
                        return param;

                    return param.join('=');
                }).join('|').replace(/^\|+/, '');;
            },
            //Localstorage test
            isAvailableLocalStorage(){
                try {
                    localStorage.__test = 1;
                    return true;
                } catch (e) {
                    return false;
                }
            },
            setProducts(){
                this.products = this.default_products = window.Laravel.data.products;
            },
            setCookie(cname, cvalue, mins) {
                var d = new Date();
                d.setTime(d.getTime() + (mins*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },
            getSubcategory(){
                //Get selected subcategory
                if ( ! this.subcategoryid )
                    return;

                for ( var key in this.category.subs )
                {
                    if ( this.category.subs[key].id == this.subcategoryid )
                    {
                        this.subcategory = this.category.subs[key];
                        break;
                    }
                }
            },
            updateResult(value){
                //if is empty search query, but is not static template...
                if ( value.length == 0 ){
                    this.searching = false;
                }

                //Returns to previous url after searching is gone
                if ( !this.canSearch ){
                    history.pushState(null, null, this.previousurl);
                    return;
                }

                this.loading = true;

                this.prices.selected = null;
                for ( var key in this.variants )
                    this.variants[key] = null;

                $.get(this.searchaction, { query : value }, function(response){
                    this.closeMenuIfIsOpened();

                    this.loading = false;

                    this.searching = value.length > 0;

                    this.products = response;

                    value = value.replace(/\s/g, '-');

                    history.replaceState(null, null, this.searchaction.replace('/ajax/', '/') + '/hladaj-vsetko/' + value);

                    this.resetMaximum();

                    this.scrollOnProductsWrapper(50);
                }.bind(this));

                //Pixel tracking for facebook
                fbq('track', 'Search', {
                    search_string: value
                });
            },
            closeMenuIfIsOpened(){
                if ( !window.isMobilDevice ){
                    return;
                }

                $('#menu-categories.in').removeClass('in');
            },
            asset(value){
                return this.$root.basepath + value;
            },
            limit(title, limit){
                if ( ! limit )
                    var limit = 20;

                return (''+title).length > limit ? (title.substr(0, limit) + '...') : title;
            },
            addMaximum(load){
                //Set default rows limit
                if ( !('vertical' in this.layout.default_maximum) )
                {
                    this.layout.default_maximum = {
                        vertical : this.layout.maximum.vertical,
                        horizontal : this.layout.maximum.horizontal
                    };
                }

                //Add rows by layout
                this.layout.maximum[this.layout.size] += (this.layout.size == 'vertical' ? 8 : 2);

                //Set hash of products limit
                this.setHashQuery('limit', this.layout.maximum[this.layout.size]);

                //Enable auto adding rows by scrolling
                if ( load )
                    this.layout.autolimit = true;
            },
            resetMaximum(){
                this.layout.maximum = ('vertical' in this.layout.default_maximum) ? this.layout.default_maximum : this.layout.maximum;
            },
            bootStaticTemplate(){
                var timeout = 500;

                //if is static template, enable showing them...
                if ( this.static == true )
                {
                    this.reset = true;

                    $('html, body').animate({
                        scrollTop: 0
                    }, 300);
                }

                /*
                 * Scrolling for more products
                 */
                setTimeout(function(){
                    $(window).scroll(function(e){
                        if ( !this.static || this.layout.autolimit == false )
                            return;

                        var top = $(document).scrollTop() + $(window).height();

                        if ( this.products.length > this.maximumRows && top + 400 >= $(document).height() )
                        {
                            this.addMaximum()
                        }
                    }.bind(this))
                }.bind(this), timeout);
            },

            /*
             * Filter products by price
             */
            filterByPrice(products, selected){
                return products.filter(function(row){
                    var price = parseFloat(row.price);

                    if ( price >= selected[0] && price < selected[1] )
                        return row;

                    return;
                });
            },

            /*
             * Change products layout grid
             */
            changeLayout(layout){

                //Get id for category to localstorage
                var id = this.category ? this.category.id : 'all';

                this.layout.size = layout;

                localStorage.setItem( 'category-' + id, layout );
            },

            /*
             * Get layout from localstorage or category
             */
            setDefaultLayout(){
                //Reset maximum of rows
                this.resetMaximum();

                //Get id for category to localstorage
                var id = this.category ? this.category.id : 'all';

                var fromStorage = localStorage.getItem('category-' + id);

                if ( !fromStorage && this.category)
                    fromStorage = this.category.layout;

                this.changeLayout(fromStorage ? fromStorage : 'vertical');

            },

            /*
             * Reset rows to empty, or to rows from static template...
             */
            resetSearching(){
                this.products = this.default_products;
                this.category = window.Laravel.data.category;

                this.getSubcategory();
            },

            /*
             * Change subdirectory
             */
            changeSubCategory(item){
                //Reset maximum rows
                this.resetMaximum();

                this.subcategory = item;

                for ( var key in this.variants )
                    this.variants[key] = null;

                var path = this.categoryaction + (item ? ('/' + item.slug) : '');

                this.previousurl = path;
                history.pushState(null, null, path);

                this.show_content = false;

                this.scrollOnProductsWrapper();
            },

            scrollOnProductsWrapper(offset){
                if ( window.isMobilDevice && $('#productWrapper').length ) {
                    $('html, body').animate({
                        scrollTop: $('#productWrapper').offset().top - 200 - (offset||0),
                    }, 500);
                }
            },

            getImagePath(product, type){
                if ( !product.image )
                    return this.asset('uploads/settings/default_image/' + type + '/' + window.Laravel.data.default_image);

                var is_allowed_second_image = this.layout.size == 'vertical';

                return this.asset('uploads/products/image'+(product.image2 && is_allowed_second_image ? 2 : '')+'/' + type + '/' + (product[is_allowed_second_image ? 'image2' : 'image']||product.image));
            },

            getProductAction(product){
                return window.Laravel.requests.product.replace(':id', product.id).replace(':slug', product.slug);
            },
            productsInSubCategory(subcategory){
                //Filter by category
                return this.products.filter(function(item){
                    if ( _.find(item.subcategories, { id : subcategory.id }) )
                        return item;
                }.bind(this)).length;
            },
            addToBasket(product){
                this.$root.setMessage('Vyberte prosím variantu produktu.', 'empty', 'add-to-basket', JSON.stringify(product));
            }
        }
    }
</script>
